import { HELPDESK_STATUSES } from "@seagames/contracts";
import { useTranslation } from "react-i18next";
import { StatusGuide, type StatusGuideGroup } from "../common/status-guide";
import { TICKET_STATUS_TONE } from "./status";

/**
 * The ticket group of a Statuses guide (PLAN §0c item 4, her `tk` guide),
 * built from the SAME list and colours the chips use. Pages that show room
 * states too (NOC rooming, Hotel) add it after S4's rooming groups.
 */
export function useTicketGuideGroup(heading?: string): StatusGuideGroup {
	const { t } = useTranslation("helpdesk");
	return {
		key: "tickets",
		heading,
		items: HELPDESK_STATUSES.map((s) => ({ key: s, color: TICKET_STATUS_TONE[s].dot, label: t(`status.label.${s}`), description: t(`status.hint.${s}`) })),
	};
}

/** "Statuses" on the Helpdesk tab: "Helpdesk statuses". */
export function HelpdeskStatusGuide() {
	const { t } = useTranslation("helpdesk");
	const group = useTicketGuideGroup();
	return <StatusGuide title={t("guide.title")} groups={[group]} />;
}
